import { ReturnBlock } from "../../../ReturnBlock";

/**
 * Boolean OR operation
 */
export class ORBlock extends ReturnBlock {
    inputs;

    /**
     * Constructor
     * @param inputs the inputs being processed
     */
    constructor(id: string, inputs: ReturnBlock[]) {
        super(id)
        this.inputs = inputs;
    }

    /**
     * Performs boolean OR operation on inputs
     * @param {Map} varEnv the variable envornment
     */
    evalBlock(varEnv: Map<string, any>): boolean {
        for (let inp of this.inputs) {
            let val = Boolean(inp.evalBlock(varEnv));
            if (val) return true;
        }
        return false;
    }
}